import Header from "../../components/Header/Header";
import unsortedIcon from "../../assets/images/png/upDown.png";
import sortedIcon from "../../assets/images/png/sortedIcon.png";
import sortedAtoz from "../../assets/images/png/descSortIcon.png";
import { Observer } from "mobx-react";
//import { ReactComponent as DownArrow } from "../../assets/images/svg/downarrow.svg";
//import PopupMenu from "../../components/PopupMenu/PopupMenu";
import { useEffect, useRef, useState } from "react";
import RadioGroup from "../../components/Reports/RadioGroup";
import {
  TaxtimePeriodRadioBtnsData,
  assetClassData,
  changesRadioBtnsData,
  REPORTS_PAGE,
  TAX,
  oneDayDif,
  taxReportTabs,
  taxReportAlphanumKeys,
  taxReportNumberKeys,
  taxReportDateKeys,
  taxReportBulletPoints,
  taxAccountDDPosition,
  errorModalPadding,
  OFFSHORE,
  dateErrorMessagetaxReport,
  homePageRoute,
  exportDataMenuTaxReport,
} from "../../utils/constants";
import GoldenDropDown from "../../components/Reports/GoldenDropDown";
import FilledButton from "../../components/SelectButton/FilledButton";
import EmptyButton from "../../components/SelectButton/EmptyButton";
import ApplyFilter from "../../components/Reports/ApplyFilter";
import Tabs from "../../components/Tabs";
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
} from "../../components/Accordion/Accordion";
import noData from "../../assets/images/svg/noData.svg";
import downArrowBlack from "../../assets/images/svg/downArrowBlack.svg";
import upArrowBlack from "../../assets/images/svg/upArrowBlack.svg";
import breadCrumbArrow from "../../assets/images/svg/breadCrumbArrow.svg";
import Modal from "../../components/Modal";
import ArrowButton from "../../components/ArrowButton";
import Table from "../../components/TaxReportTable/TaxReportTable";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import emailSuccess from "../../assets/images/svg/emailSuccess.svg";
import homeBtnIcon from "../../assets/images/svg/homeBtnIcon.svg";
import { setCookie, getCookie } from "../../utils/cookie";
import {
  calenderSetterTaxReport,
  commaSeperated,
  convertDateToObj,
  formatDate,
  getAsOfDate,
  getDecodedToken,
  getDisplayClms,
  getDisplayDate,
  getDisplayDate2,
  getMonth,
  getOffshoreData,
  getSecond,
  getTaxPDFDate,
  logEvents,
  trackEventWithScreen,
  validateTaxReportDate,
} from "../../utils/functions";
import DatePicker2 from "../../components/Reports/DatePicker2";
import { observer } from "mobx-react-lite";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import { useNavigate } from "react-router";
import SortTable2 from "../../utils/Hooks/SortTable2";
import ReportsStore from "../../store/ReportsStore";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import OverflowingText from "../../components/OverflowingText/OverflowingText";
import { useMemo } from "react";
import { useCallback } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import PageHeading from "../../components/PageHeading/PageHeading";
import ExportReportList from "../../components/AccessibleDropdown/ExportReportList";
import DropdownWithOptions from "../../components/Reports/UnrealisedGLReport/DropdownWithOptions";

// const PopupButton = () => {
//   return (
//     <div className="export_data_btn">
//       <p className="export_data_text">Export Data</p>
//       <div className="export_text_wrapper">
//         <p className="export_type">Excel</p>
//         <DownArrow />
//       </div>
//     </div>
//   );
// };

const ErroModalContent = ({ msg, onClick }) => {
  return (
    <div className="home_popup_container">
      <svg
        width="50"
        height="49"
        viewBox="0 0 50 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.9842 48.5214C23.6646 48.5214 22.4421 47.9259 21.6287 46.8858L16.7344 40.679L8.15511 40.6737C3.93446 40.6737 0.5 37.2393 0.5 33.0175V8.03905C0.5 3.81728 3.93446 0.382812 8.15623 0.382812H41.8437C46.0654 0.382812 49.4999 3.81728 49.4999 8.03905V23.4472C49.4999 24.5044 48.6431 25.3613 47.5858 25.3613C46.5286 25.3613 45.6718 24.5044 45.6718 23.4472V8.03905C45.6718 5.92835 43.9544 4.21093 41.8437 4.21093H8.15623C6.04554 4.21093 4.32812 5.92835 4.32812 8.03905V33.0175C4.32812 35.1282 6.04554 36.8456 8.15623 36.8456L17.6645 36.8512C18.2503 36.8516 18.8036 37.1204 19.1662 37.5802L24.6396 44.5213C24.7513 44.6645 24.8878 44.6933 24.9846 44.6933H24.9865C25.0829 44.6929 25.2205 44.6634 25.3274 44.5247C25.3308 44.5202 25.3342 44.5157 25.3375 44.5116L30.7664 37.5795C31.1294 37.1163 31.6849 36.8456 32.2734 36.8456H41.8437C43.9547 36.8456 45.6718 35.1282 45.6718 33.0175C45.6718 31.9603 46.5286 31.1035 47.5858 31.1035C48.6431 31.1035 49.4999 31.9603 49.4999 33.0175C49.4999 37.2393 46.0654 40.6737 41.8437 40.6737H33.2057L28.3555 46.8664C27.5465 47.9132 26.3248 48.5162 25.0014 48.5214C24.9958 48.5214 24.9899 48.5214 24.9842 48.5214ZM26.914 29.5722V19.2363C26.914 18.1791 26.0572 17.3222 25 17.3222C23.9427 17.3222 23.0859 18.1791 23.0859 19.2363V29.5722C23.0859 30.6294 23.9427 31.4863 25 31.4863C26.0572 31.4863 26.914 30.6294 26.914 29.5722ZM25 10.7187C23.9427 10.7187 23.0859 11.5756 23.0859 12.6328C23.0859 13.69 23.9427 14.5468 25 14.5468C26.0572 14.5468 26.914 13.69 26.914 12.6328C26.914 11.5756 26.0572 10.7187 25 10.7187Z"
          fill="#E12014"
        />
      </svg>
      <p className="home_popup_info_text">{msg}</p>
      <div className="home_page_popup_arrow_btn">
        <ArrowButton
          onClick={onClick}
          type={"next"}
          label={"Got it"}
          styleProp={{
            borderRadius: "15px",
          }}
        />
      </div>
    </div>
  );
};

const TableHeader = ({
  headers,
  handleFilter,
  styles,
  getSortingImage,
  sortingConfig,
  type,
  compareWithKey,
  isAscending,
}) => {
  return (
    <thead className="accordion_table_header">
      <tr>
        {headers?.map((header, index) => (
          <th
            key={index}
            aria-sort={
              compareWithKey === header.key
                ? isAscending
                  ? "Ascending"
                  : "Descending"
                : undefined
            }
            className={`accordion_table_header_child ${header.className}`}
            style={{
              width: header.width,
              ...styles,
            }}
          >
            {header.sortable ? (
              <button
                className="table-header-button"
                onClick={() => handleFilter(header.title, header.key)}
              >
                <p className="accordion_table_header_child_heading blueTextColor">
                  {header.title}
                </p>
                {header.sortable && (
                  <div
                    aria-hidden={true}
                    className="accordion_table_header_child_icon"
                    style={{
                      height: 12,
                      width: 12,
                    }}
                  >
                    <img
                      src={getSortingImage({ key: header.key })}
                      alt="sort"
                    />
                  </div>
                )}
              </button>
            ) : (
              <div>
                <p className="accordion_table_header_child_heading blueTextColor">
                  {header.title}
                </p>
              </div>
            )}
          </th>
        ))}
      </tr>
    </thead>
  );
};

const TableAccordion = ({
  currentOpenAccordion,
  // rowData,
  headers,
  // idx,
  handleAccordion,
  columns,
  headerRenderer,
  accordionData,
  rowRenderer,
  className,
  tableClass,
  styles,
  handleFilter,
  type,
  getSortingImage,
  arrData,
  tableData,
  totalValues,
  totalClass,
  compareWithKey,
  isAscending,
  ...rest
}) => {
  return (
    <>
      <table className={tableClass}>
        <TableHeader
          headers={headers}
          handleFilter={(title, key) => handleFilter(title, key)}
          styles={styles}
          type={"Asset"}
          getSortingImage={({ key }) =>
            getSortingImage({
              key,
            })
          }
          compareWithKey={compareWithKey}
          isAscending={isAscending}
        />

        <tbody
          className={`accordion_table_data ${
            tableData?.length === 1 ? "single_row" : ""
          }`}
        >
          <>
            {arrData?.map((rowData, idx) => (
              <>
                <Accordion>
                  <AccordionHeader
                    open={currentOpenAccordion === rowData.displayName}
                    {...rest}
                  >
                    {headers?.map(
                      (headers) =>
                        headers.cellRenderer &&
                        headers.cellRenderer({
                          ...headers,
                          rowData,
                          idx,
                          handleAccordion: (name, idx, rowData) =>
                            handleAccordion(name, idx, rowData),
                        }),
                    )}
                  </AccordionHeader>
                  <AccordionContent
                    open={currentOpenAccordion === rowData.displayName}
                  >
                    <table className="table accordion_content_custom_table tax_report ">
                      <thead>
                        <tr
                          style={{
                            border: "26px solid transparent",
                            borderTop: 0,
                          }}
                        >
                          {columns?.map(headerRenderer)}
                        </tr>
                      </thead>
                      <tbody
                        className={`${
                          rowData.accordionContent?.length === 1
                            ? "single_data"
                            : ""
                        }`}
                        style={{
                          border: "26px solid transparent",
                          borderTop: 0,
                        }}
                      >
                        {accordionData?.map((eachRowData, index) => {
                          return (
                            <>
                              {rowRenderer(eachRowData, index)}
                              {index >= 0 &&
                                index < accordionData.length - 1 && (
                                  <div className={className} />
                                )}
                            </>
                          );
                        })}
                      </tbody>
                    </table>
                  </AccordionContent>
                </Accordion>
              </>
            ))}
          </>
        </tbody>
      </table>
      <table className={totalClass}>
        <thead>
          <th>
            <p>Total</p>
          </th>
          {totalValues?.map(({ value }) => (
            <th>
              <p> {commaSeperated(value)}</p>
            </th>
          ))}

          <th style={{ visibility: "hidden" }}>
            <p></p>
          </th>
        </thead>
      </table>
    </>
  );
};

const NoDataScreen = () => {
  return (
    <div className="noDataTab">
      <img src={noData} alt="no_data" />
      <h3>You do not have any records to display</h3>
    </div>
  );
};

const TaxReport = observer(() => {
  const storedAsOfDate = getAsOfDate(UserStore.asOfDate);
  const asOfDate = storedAsOfDate ? storedAsOfDate : getCookie("asOfDate");
  // const [niftyMenu, setNiftyMenu] = useState(false);
  const [timePeriod, setTimePeriod] = useState("current_month");
  const [fromDate, setFromDate] = useState(convertDateToObj(asOfDate));
  const [toDate, setToDate] = useState(convertDateToObj(asOfDate));
  const [initialFromDate, setInitialFromDate] = useState(null);
  const [initialToDate, setInitialToDate] = useState(null);
  const [selectedAssetClass, setSelectedAssetClass] = useState(
    assetClassData[0],
  );

  const [selectedUser, setSelectedUser] = useState(
    getDecodedToken()?.user_type === "employee" ? "selfEmail" : "clientEmail",
  );
  const [selectedUsersName, setSelectedUsersName] = useState(
    getDecodedToken()?.user_type === "employee" ? "selfName" : "clientName",
  );

  const [allAssetClassMenuOpen, setAllAssetClassMenuOpen] = useState(false);
  // const [allAssetClassMenuOpen1, setAllAssetClassMenuOpen1] = useState(false);
  const [datePickerModalOpen, setDatePickerModalOpen] = useState(false);
  const [filteredColumn, setFilteredColumn] = useState("");
  const [currentOpenAccordion, setCurrentOpenAccordion] = useState("");
  const [currentStep, setCurrentStep] = useState("0");
  const [breadCrumbData, setBreadCrumbData] = useState({
    assetClass: "",
    subAssetClass: "",
  });
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [emailReportToOpen, setEmailReportToOpen] = useState(false);
  const [table, setTable] = useState([]);
  const [showTable, setShowTable] = useState([]);
  const [sortedColumn, setSortedColumn] = useState("");
  const [updating, setUpdating] = useState(false);
  const [isSortedColumnAscending, setIsSortedColumnAscending] = useState(false);
  const [emailReportSuccessOpen, setEmailReportSuccessOpen] = useState(false);
  const [resetedFromDate, setResetedFromDate] = useState(null);
  const [resetedToDate, setResetedToDate] = useState(null);
  const [accordionTable, setAccordionTable] = useState([]);
  // const [asDatArr] = useState(asOfDate?.split("-"));
  // const [minDate, setMinDate] = useState(
  //   `${asDatArr[0] - 2}-${asDatArr[1]}-${asDatArr[1]}`
  // );
  const [userAccounts, setUserAccounts] = useState([
    ...ReportsStore.usersAccounts,
  ]);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isTableScrolled, setIsTableScrolled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openErrorModal, setOpenErrorModal] = useState(false);

  const navigate = useNavigate();

  const scrollRef = useRef();

  //const exportTaxRef = useRef(null);
  const exportItemRefs = useRef([]);

  // const bodyRef = useRef();
  // const firstColumnRef = useRef();
  // const headerRef = useRef();
  const tBodyRef = useRef(null);

  // const ref = useRef(null);

  const accounts = ReportsStore.usersAccounts;
  const userHydrated = UserStore.isHydrated;
  const emailSendSuccess = ReportsStore.emailSendSuccess;
  const emailDataSuccess = ReportsStore.emaiDataGetSuccess;
  const storeSelectedUser = UserStore.emailIdDataForTax?.[selectedUser];

  // const onClickOutside = useCallback(() => {
  //   setNiftyMenu(false);
  // }, []);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (
  //       exportTaxRef.current &&
  //       !exportTaxRef.current.contains(event.target)
  //     ) {
  //       onClickOutside && onClickOutside();
  //     }
  //   };
  //   document.addEventListener("click", handleClickOutside, true);
  //   return () => {
  //     document.removeEventListener("click", handleClickOutside, true);
  //   };
  // }, [onClickOutside]);

  const { isAscending, key1, arrData, setKeyForOrdering } = SortTable2(
    ReportsStore.taxType === "Asset"
      ? ReportsStore.assetData
      : ReportsStore.interestData,
    { key1: ReportsStore.taxType === "Asset" ? "shortTerm_GL" : "amount" },
    false,
  );

  const {
    isAscending: isTableAscending,
    key1: tableKey,
    arrData: tableData,
    setKeyForOrdering: setTableKey,
  } = SortTable2(
    table,
    { key1: ReportsStore.taxType === "Asset" ? "" : "amount" },
    false,
  );

  const {
    isAscending: isAccordionAscending,
    key1: accordionKey,
    arrData: accordionData,
    setKeyForOrdering: setAccordionKey,
  } = SortTable2(
    accordionTable,
    { key1: ReportsStore.taxType === "Asset" ? "longTerm_GL" : "amount" },
    false,
  );

  const getDisplayDateLocal = (data) => {
    const newData = data ? data : "-";

    if (newData === "-") {
      return newData;
    } else if (newData?.includes("-")) {
      return getDisplayDate(newData);
    } else if (newData?.includes("/")) {
      return getDisplayDate2(newData);
    } else {
      return "-";
    }
  };

  const instrumentAmtCellRenderer = (_, data, key) => {
    const commonKeys = {
      buyPrice: true,
      gfPrice: true,
      sellPrice: true,
      sellValue: true,
      sttSell: true,
      longTermCapitalGainsWithoutIndexation: true,
      longTermCapitalGainsWithIndexation: true,
    };

    if (key === "quantity") {
      return (
        <div className="instrument_name_cell  font-roboto ">
          {data[key] ? commaSeperated(data[key]) : "-"}
        </div>
      );
    } else if (commonKeys[key]) {
      return (
        <div className="instrument_name_cell max_width font-roboto">
          {data[key] ? commaSeperated(data[key]) : "-"}
        </div>
      );
    } else {
      return (
        <div className="instrument_name_cell max_width font-roboto">
          {data[key] ? commaSeperated(data[key]) : "-"}
        </div>
      );
    }
  };

  const instrumentNameCellRenderer = (_, data, key) => {
    return (
      <div className="instrument_name_cell max_width">
        {data[key] && isNaN(data[key])
          ? data[key]
          : data[key] && data[key] !== "0"
            ? commaSeperated(data[key])
            : "-"}
      </div>
    );
  };

  const folioRenderer = (_, data, key) => {
    return (
      <div className="instrument_name_cell max_width">{data[key] || "-"}</div>
    );
  };

  const instrumentNameCellRenderer2 = (_, data, key) => {
    return (
      <>
        <OverflowingText
          text={data[key]}
          width={190}
          ellipsisTextClassName={"_tax_report_ins_name_class"}
          position="right"
        />
      </>
    );
  };

  const instrumentDateCellRenderer = (_, data, key) => {
    if (key === "sellDate") {
      return (
        <div className="instrument_name_cell max_width">
          {!data?.ledger_Type
            ? data?.redemptionDate
              ? getDisplayDateLocal(data?.redemptionDate)
              : "-"
            : data[key]
              ? getDisplayDateLocal(data[key])
              : "-"}
        </div>
      );
      //}
    } else {
      return (
        <div className="instrument_name_cell max_width">
          {data[key] ? getDisplayDateLocal(data[key]) : "-"}
        </div>
      );
    }
  };

  const [taxReportEditColumnsNames, seTtaxReportEditColumnsNames] = useState([
    {
      label: "Security Name",
      key: "displayName",
      checked: true,
      sortable: false,
      cellRenderer: instrumentNameCellRenderer,
      id: 0,
      //1
    },
    {
      label: "ISIN",
      checked: false,
      key: "isin",
      sortable: false,
      cellRenderer: instrumentNameCellRenderer,
      id: 1,
      //prev
    },
    {
      label: "Folio No.",
      key: "folioNo",
      checked: false,
      id: 2,
      sortable: true,
      cellRenderer: folioRenderer,
    },
    {
      label: "Security Class",
      key: "securityClass",
      checked: false,
      sortable: false,
      cellRenderer: instrumentNameCellRenderer,
      id: 3,
      //prev
    },
    {
      label: "Quantity/Units",
      key: "quantity",
      checked: true,
      sortable: false,
      cellRenderer: instrumentAmtCellRenderer,
      id: 4,
      //prev
    },
    {
      label: "Buy Date",
      key: "buyDate",
      checked: true,
      //2
      sortable: false,
      cellRenderer: instrumentDateCellRenderer,
      id: 5,
    },
    {
      label: "Sell Date",
      key: "sellDate",
      //3
      checked: true,
      sortable: false,
      cellRenderer: instrumentDateCellRenderer,
      id: 6,
    },
    {
      label: "Buy Price in Rs",
      key: "buyPrice",
      checked: true,
      sortable: false,
      cellRenderer: instrumentAmtCellRenderer,
      id: 7,
      //prev
    },
    {
      label: "GF Price in Rs",
      key: "gfPrice",
      checked: true,
      sortable: false,
      cellRenderer: instrumentAmtCellRenderer,
      id: 8,
      //prev
    },

    {
      label: "Sell Price in Rs",
      key: "sellPrice",
      checked: true,
      id: 9,
      sortable: false,

      cellRenderer: instrumentAmtCellRenderer,
    },
    {
      label: "Buy Value in Rs",
      key: "buyValue",
      checked: true,
      id: 10,
      sortable: false,
      cellRenderer: instrumentAmtCellRenderer,
      //4
    },

    {
      label: "Sell Value in Rs",
      key: "sellValue",
      checked: true,
      id: 11,
      sortable: false,
      //5
      cellRenderer: instrumentAmtCellRenderer,
    },
    {
      label: "Indexation Price",
      key: "indexationPrice",
      checked: false,
      id: 12,
      sortable: false,
      cellRenderer: instrumentAmtCellRenderer,
    },
    {
      label: "Indexation value",
      key: "indexationValue",
      checked: false,
      id: 13,
      sortable: false,
      cellRenderer: instrumentAmtCellRenderer,
    },
    {
      label: "LTP",
      key: "ltp",
      checked: false,
      id: 14,
      sortable: false,
      cellRenderer: instrumentAmtCellRenderer,
    },
    {
      label: "Taxable G/L with Indexation",
      key: "longTermCapitalGainsWithIndexation",
      checked: false,
      id: 15,
      sortable: false,
      cellRenderer: instrumentAmtCellRenderer,
      classn: "big_col_1",

      currentSortKey: key1,
    },
    {
      label: "Gain/Loss",
      key: "longTermCapitalGainsWithoutIndexation",
      checked: true,
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      classn: "big_col_2",
      //6
      id: 16,
      currentSortKey: key1,
    },

    {
      label: "Holding Days",
      key: "holdingDays",
      checked: false,
      id: 17,
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Short Term Gain/Loss",
      key: "shortTerm_GL",
      checked: false,
      id: 18,
      //7
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },

    {
      label: "Brokerage",
      key: "brokerage",
      checked: false,
      id: 19,
      sortable: false,
      cellRenderer: instrumentAmtCellRenderer,
    },
    {
      label: "Stamp Duty",
      key: "stampDuty",
      checked: false,
      id: 20,
      sortable: false,
      cellRenderer: instrumentAmtCellRenderer,
    },
    {
      label: "STT Buy",
      key: "sttBuy",
      checked: false,
      id: 21,
      sortable: false,
      cellRenderer: instrumentAmtCellRenderer,
    },

    {
      label: "Other Charges Buy",
      checked: false,
      id: 22,
      sortable: false,
      cellRenderer: instrumentAmtCellRenderer,
    },
    {
      label: "STT Sell",
      checked: false,
      key: "sttSell",
      id: 23,
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
    },

    {
      label: "Other Charges Sell",
      key: "otherChargesSell",
      checked: false,
      id: 24,
      sortable: false,
      cellRenderer: instrumentAmtCellRenderer,
    },
  ]);

  const [columnsToDisplay, setColumnsToDisplay] = useState([]);
  const [, setIntColumnsToDisplay] = useState([]);
  const handleTimePeriodChange = (selectedTimePeriod) => {
    setTimePeriod(selectedTimePeriod);
  };

  const handleChangesRadioChange = (selectedchange) => {};

  const handlePdfClick = useCallback(
    (data, emailID, usersName) => {
      ReportsStore.setITaxSendEmail(data);
      const time = "T00:00:00+05:30";
      const todaysDate = new Date();
      ReportsStore.downloadPdf(
        `${fromDate.year}-${fromDate?.month}-${fromDate.date}${time}`,
        `${toDate.year}-${toDate?.month}-${toDate.date}${time}`,
        `${todaysDate.getFullYear()}-${getMonth(
          todaysDate.getMonth(),
        )}-${getSecond(todaysDate.getDate())}T${getSecond(
          todaysDate.getHours(),
        )}:${getSecond(todaysDate.getMinutes())}:${getSecond(
          todaysDate.getSeconds(),
        )}+05:30`,
      );
    },
    [fromDate, toDate],
  );

  const handleEmailREport = (data) => {
    ReportsStore.setITaxSendEmail(data);
    const userType = getDecodedToken()?.user_type;
    if (userType === "customer" || userType === "manager") {
      handlePdfClick("1");
      return;
    } else {
      ReportsStore.getEmailIdForTax(getCookie("selectedUsersId"));
    }
  };
  const handleClickToDownload = ({ path }) => {
    const win = window.open(path, `_blank`);
    if (win != null) {
      win.focus();
    }
  };

  // const ExtractDataContent = () => {
  //   const exportExcel = () => {
  //    // setNiftyMenu(false);
  //     ReportsStore.setITaxSendEmail("0");
  //     ReportsStore.setTaxDates(fromDate, "taxFromDate");
  //     ReportsStore.setTaxDates(toDate, "taxToDate");
  //     ReportsStore.setDownloadTrigger([...ReportsStore.downloadTrigger, {}]);
  //     handleClickToDownload({ path: "download" });
  //   };

  //   const exportPdf = () => {
  //     // Opens new tab for downloading pdf and in use effect we are calling api for pdf
  //     // Allroutes page downloads the actual file by the auto click on a anchor tag and using cookies

  //     const pdfFromDate = getTaxPDFDate({
  //       data: fromDate,
  //     });
  //     const pdfToDate = getTaxPDFDate({ data: toDate });

  //     ReportsStore.setTaxDates(pdfFromDate, "taxPdfDownloadFromDate");
  //     ReportsStore.setTaxDates(pdfToDate, "taxPdfDownloadToDate");
  //    // setNiftyMenu(false);
  //     ReportsStore.setDownloadTrigger([...ReportsStore.downloadTrigger, {}]);
  //     handleClickToDownload({
  //       path: `tax-report/pdf-file-download`,
  //     });
  //   };

  //   return (
  //     <div ref={ref} className="extract_data_container downloadPdf">
  //       <p className="export_data_text">Export Data</p>
  //       <ul className="listitem_container">
  //         <li onClick={exportExcel}>
  //           <div className="listitem_icon excel"></div> Export to Excel
  //         </li>
  //         <li onClick={exportPdf}>
  //           <div className="listitem_icon new_pdf"></div> Export to PDF
  //         </li>
  //         <li
  //           onClick={() => {
  //            // setNiftyMenu(false);
  //             handleEmailREport("1");
  //           }}
  //         >
  //           <div className="listitem_icon pdf"></div> Email Report
  //         </li>
  //       </ul>
  //     </div>
  //   );
  // };

  const AllAssetClassMenuContent = () => {
    const handleChange = (account) => {
      setSelectedAssetClass(account);
    };
    return (
      <ul className="portfolio_report_accounts_container">
        {assetClassData.map((accountData, index) => (
          <li className="account_listitem">
            <div
              className="radio_btn_input"
              onClick={() => handleChange(accountData)}
            >
              {accountData.id === selectedAssetClass.id ? (
                <FilledButton />
              ) : (
                <EmptyButton />
              )}
            </div>
            <label
              className="radio_btn_label"
              for={accountData.id}
              style={{ display: "contents" }}
            >
              <OverflowingText
                text={accountData?.title}
                width={140}
                textClassName="radio_btn_label cursor_imp"
                tooltipOnHover={true}
                position="left"
                tooltipClassName={
                  index === 0
                    ? "asset_class_tooltip_styles_bottom"
                    : "asset_class_tooltip_styles"
                }
              />
            </label>
          </li>
        ))}
      </ul>
    );
  };

  useEffect(() => {
    if (ReportsStore.usersAccounts.length !== 0) {
      let arr1 = ReportsStore.usersAccounts;
      const userID = getCookie("userid");
      const objectsToMove = arr1.filter(
        (obj) => obj.user_id === parseInt(userID, 10),
      );
      let updatedArr = [...objectsToMove];
      for (let i = 0; i < arr1.length; i++)
        if (!objectsToMove.some((el) => el.user_id === arr1[i].user_id))
          updatedArr.push(arr1[i]);
      setUserAccounts([...updatedArr]);
      ReportsStore.setSelectedAccount(updatedArr[0]);
    }
  }, [
    accounts?.length,
    //  ReportsStore.usersAccounts?.length
  ]);

  const BeforeEditColumnModalOpen = ({ assetClass }) => {
    const arr = columnsToDisplay;
    const arr2 = taxReportEditColumnsNames;

    const mappedArray = [...arr2]?.map((data, idx) => {
      const newArr = arr?.filter((eachData) => eachData.id === data.id);
      if (newArr?.length !== 0) {
        return { ...data, checked: true };
      } else {
        return { ...data, checked: false };
      }
    });

    let filterClm = [];
    // this function is called from accordion and when we open the filter
    // asset class is passed only from the accordion
    // when we open the filter we are sure that we are doing it for the same asset class
    // we require asset class because for mutual funds there is one extra column (Folio no.)
    // so we are adding and removing this folio no. clm from table and from filter according to asset class
    if (assetClass) {
      const idxOfFolioClm = mappedArray?.findIndex((clms) => clms.id === 2);
      if (assetClass !== "Mutual Funds") {
        filterClm =
          idxOfFolioClm === -1
            ? mappedArray
            : mappedArray?.filter((arr) => arr.id !== 2);
        // if previous table is of mutual funds then we have to remove folio colmn from displaycolm and from colums used in filters
        // but in mutual funds we need not to remove the folio columns thats why we are setting it here only.
        setColumnsToDisplay((prev) => prev.filter((clm) => clm.id !== 2));
      } else {
        const idxOfISINClm = mappedArray?.findIndex((elem) => elem.id === 1);
        // in filter modal the folio clm should come after isin column and while displaying the table ,
        // if isin clm is present then folio clm will come after it otherwise
        // if we have to display folio clm then its position will be 1
        // so in case when we have we first opened the mutual funds and again we open other sub asset under mutual funds the when again we
        // click the sub asset we are sure that folio clm will be there and we dont have to alter the clms then so we will as it is place the clms without else
        // and if folio clm is not present then we will check is isin is present or not and if isin in there then folio clms position will be 2 otherwise it will be 1
        if (idxOfFolioClm === -1)
          mappedArray.splice(idxOfISINClm === -1 ? 1 : 2, 0, {
            label: "Folio No",
            key: "folioNo",
            checked: false,
            id: 2,
            sortable: true,
            cellRenderer: folioRenderer,
          });
        filterClm = mappedArray;
      }
    } else filterClm = [...mappedArray];

    seTtaxReportEditColumnsNames(filterClm);
  };

  const FilterModalContent = () => {
    const handleSubmit = () => {
      setColumnsToDisplay(
        getDisplayClms({
          sourceArr: columns2,
          refArr: taxReportEditColumnsNames,
        }),
      );
      setOpenFilterModal(false);
    };
    const handleClick = (index, isChecked, id) => {
      let arr = taxReportEditColumnsNames;
      arr[index].checked = !isChecked;

      if (id !== 0) {
        seTtaxReportEditColumnsNames(
          taxReportEditColumnsNames.map((taxColumn, idx) => {
            if (id === taxColumn.id && taxColumn.id !== 0) {
              return { ...taxColumn, checked: !isChecked };
            } else {
              return taxColumn;
            }
          }),
        );
      }
    };

    return (
      <>
        <div className="column_names_container">
          {taxReportEditColumnsNames?.map((eachColumnName, index) => (
            <button
              className={`column_name_btn ${
                eachColumnName.checked && eachColumnName.id !== 0
                  ? "is-active"
                  : eachColumnName.checked && eachColumnName.id === 0
                    ? "not_allowed"
                    : ""
              }`}
              onClick={() => {
                eachColumnName.id !== 0 &&
                  handleClick(index, eachColumnName.checked, eachColumnName.id);
              }}
              tabIndex={-1}
            >
              {eachColumnName.label}
            </button>
          ))}
        </div>
        <div className="tax_report_filter_column_footer">
          <button
            className="tax_report_reset_btn"
            onClick={() => {
              handleResetOutSide();
            }}
          >
            Reset
          </button>
          <ArrowButton type={"next"} label={"Apply"} onClick={handleSubmit} />
        </div>
      </>
    );
  };

  const accordionHeaderRenderer = ({
    key,
    rowData,
    idx,
    width,
    handleAccordion,
  }) => {
    const newKey =
      key === "name" ? "displayName" : key === "amount" ? "shortTerm_GL" : key;

    switch (newKey) {
      case "displayName":
        return (
          <td className="accordion_table_data_row_td" style={{ width: width }}>
            <div className="asset_class_wrapper">
              <p className="asset_class_text">{rowData?.displayName}</p>
            </div>
          </td>
        );
      case "shortTerm_GL":
        return (
          <td
            className="accordion_table_data_row_td short_term"
            style={{
              width: "17%",
              paddingRight: 26,
            }}
          >
            <div className="asset_class_wrapper">
              <p className="asset_class_text font-roboto">
                {commaSeperated(rowData[key])}
              </p>
            </div>
          </td>
        );
      case "longTerm_GL":
        return (
          <td
            className="accordion_table_data_row_td long_term"
            style={{ width: "17%" }}
          >
            <div className="asset_class_wrapper">
              <p className="asset_class_text font-roboto">
                {isNaN(Number(rowData?.longTerm_GL).toFixed(2))
                  ? commaSeperated(
                      rowData?.longTermCapitalGainsWithoutIndexation,
                    )
                  : commaSeperated(rowData?.longTerm_GL)}
              </p>
            </div>
          </td>
        );
      case "btn":
        return rowData.displayID === "-1" ? (
          <td
            className="accordion_table_data_row_td bbttnn"
            style={{ width: "3%" }}
          >
            <div
              className="accordion_down_btn right_arrow buttonBlueBorder"
              onClick={() => {
                setCurrentOpenAccordion("");
                setDataTable(rowData.accordionContent?.[0]?.tableData);
                setBreadCrumbData({
                  assetClass: rowData.displayName,
                  subAssetClass: rowData.displayName,
                });
                BeforeEditColumnModalOpen({ assetClass: rowData.displayName });
                setCurrentStep("1");
              }}
            >
              <img src={downArrowBlack} alt="arrow" />
            </div>
          </td>
        ) : (
          <td className="accordion_table_data_row_td" style={{ width: "3%" }}>
            <div
              className="accordion_down_btn buttonBlueBorder"
              onClick={() => handleAccordion(rowData.displayName, idx, rowData)}
            >
              <img
                src={
                  currentOpenAccordion === rowData.displayName
                    ? upArrowBlack
                    : downArrowBlack
                }
                alt="arrow"
              />
            </div>
          </td>
        );

      case "navBtn":
        return rowData.assetClass === "Derivatives" ? (
          <td
            className="accordion_table_data_row_td naavvBBttn"
            style={{ width: "3%" }}
          >
            <div
              className="accordion_down_btn right_arrow buttonBlueBorder"
              onClick={() => {
                setBreadCrumbData({
                  assetClass: rowData.displayName,
                  subAssetClass: rowData.displayName,
                });
                setCurrentStep("1");
              }}
            >
              <img src={downArrowBlack} alt="arrow" />
            </div>
          </td>
        ) : (
          <td className="accordion_table_data_row_td" style={{ width: "3%" }}>
            <div
              className="accordion_down_btn buttonBlueBorder"
              onClick={() => handleAccordion(rowData.displayName, idx, rowData)}
            >
              <img
                src={
                  currentOpenAccordion === rowData.displayName
                    ? upArrowBlack
                    : downArrowBlack
                }
                alt="arrow"
              />
            </div>
          </td>
        );
      default:
        return <></>;
    }
  };

  const accordionTableHeaderData = [
    {
      title: "Asset Class",
      sortable: false,
      width: "65%",
      key: "displayName",
      className: "asset_class_header",
      cellRenderer: accordionHeaderRenderer,
    },
    {
      title: "Short Term Gain/Loss",
      sortable: true,
      width: "17%",
      key: "shortTerm_GL",
      className: "short_term_header",
      cellRenderer: accordionHeaderRenderer,
    },
    {
      title: "Long Term Gain/Loss",
      sortable: true,
      width: "17%",
      key: "longTerm_GL",
      className: "long_term_header",
      cellRenderer: accordionHeaderRenderer,
    },
    {
      title: "Action",
      sortable: false,
      width: "3%",
      key: "btn",
      cellRenderer: accordionHeaderRenderer,
    },
  ];

  const intDivOthersaccordionTableHeaderData = [
    {
      title: "",
      sortable: false,
      width: "82%",
      key: "name",
      className: "asset_class_header",
      cellRenderer: accordionHeaderRenderer,
    },
    {
      title: "Amount",
      sortable: true,
      key: "amount",
      width: "17%",
      className: "long_term_header",
      cellRenderer: accordionHeaderRenderer,
    },
    {
      title: "Action",
      sortable: false,
      width: "3%",
      key: "navBtn",
      cellRenderer: accordionHeaderRenderer,
    },
  ];

  const handleFilter = (filterType, key) => {
    setFilteredColumn(filterType);

    setKeyForOrdering({ key1: key }, key === key1 ? !isAscending : false);

    if (filterType === filteredColumn) {
      setFilteredColumn("");
    }
  };

  const handleAccordion = (accoridonName, idx, rowData) => {
    setAccordionTable(rowData.accordionContent);

    setCurrentOpenAccordion(accoridonName);
    if (accoridonName === currentOpenAccordion) {
      setCurrentOpenAccordion("");
    }
  };

  const investedValueCellRenderer = (data, key) => {
    if (key === "displayName")
      return (
        <p className="invested_value_cell" style={{}}>
          {data?.[key]}
        </p>
      );
    else if (key === "longTerm_GL")
      return (
        <p className="invested_value_cell font-roboto" style={{}}>
          {isNaN(Number(data?.[key]).toFixed(2))
            ? commaSeperated(data?.longTermCapitalGainsWithoutIndexation)
            : commaSeperated(data?.[key])}
        </p>
      );
    else {
      return (
        <p className="invested_value_cell font-roboto" style={{}}>
          {commaSeperated(data?.[key])}
        </p>
      );
    }
  };

  const investedValueCellRenderer2 = (data, key) => {
    if (key === "displayName")
      return <p className="invested_value_cell">{data?.[key]}</p>;
    else if (key === "longTerm_GL")
      return (
        <p className="invested_value_cell font-roboto">
          {isNaN(Number(data?.[key]).toFixed(2))
            ? commaSeperated(data?.longTermCapitalGainsWithoutIndexation)
            : commaSeperated(data?.[key])}
        </p>
      );
    else {
      return (
        <p className="invested_value_cell font-roboto tax_report_accordion_cell_intdiv">
          {commaSeperated(data?.[key])}
        </p>
      );
    }
  };

  const actionCellRenderer = (eachRowData, key, idx) => {
    return (
      <div
        className="action_cell acc_btn_animation downaction buttonBlueBorder"
        onClick={() => {
          setDataTable(eachRowData?.tableData);
          setBreadCrumbData({
            assetClass: currentOpenAccordion,
            subAssetClass: eachRowData.displayName,
          });
          BeforeEditColumnModalOpen({ assetClass: currentOpenAccordion });
          setCurrentStep("1");
        }}
      >
        <svg
          width="13"
          height="8"
          viewBox="0 0 13 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.05629 5.23081L6.70312 5.58321L6.34996 5.23081L2.11351 1.0036L1.41023 1.70687L6.70312 6.99977L11.996 1.70688L11.2927 1.0036L7.05629 5.23081Z"
            stroke="#404040"
          />
        </svg>
      </div>
    );
  };
  const columns = [
    {
      label: "Sub Asset Class",
      key: "displayName",
      sortable: false,
      cellRenderer: investedValueCellRenderer,
      width: "65%",
    },
    {
      label: "Short Term Gain/Loss",
      key: "shortTerm_GL",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      width: "17%",
    },
    {
      label: "Long Term Gain/Loss",
      key: "longTerm_GL",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      width: "17%",
    },
    {
      label: "Action",
      title: "Action",
      sortable: false,
      cellRenderer: actionCellRenderer,
    },
  ];
  const intDivcolumns = [
    {
      label: "Sub Asset Class",
      key: "displayName",
      sortable: false,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Amount",
      key: "amount",
      sortable: true,
      cellRenderer: investedValueCellRenderer2,
    },
    {
      label: "Action",
      title: "Action",
      sortable: false,
      cellRenderer: actionCellRenderer,
    },
  ];

  const headerRenderer = ({ label, key, sortable, classn, width }, index) => (
    <th
      aria-sort={
        accordionKey === key
          ? isAccordionAscending
            ? "Ascending"
            : "Descending"
          : undefined
      }
      key={index}
      className={classn && classn}
      style={{ paddingLeft: label === "Sub Asset Class" ? 0 : "auto" }}
    >
      {sortable ? (
        <button
          className="header_cell"
          style={{ cursor: "pointer" }}
          onClick={() =>
            setAccordionKey(
              { key1: key },
              key === accordionKey ? !isAccordionAscending : false,
            )
          }
        >
          <p>{label}</p>
          {sortable && (
            <div
              className="accordion_table_header_child_icon"
              style={{ height: 12, width: 12 }}
            >
              <img
                src={
                  isAccordionAscending && accordionKey === key
                    ? sortedIcon
                    : !isAccordionAscending && accordionKey === key
                      ? sortedAtoz
                      : accordionKey !== key
                        ? unsortedIcon
                        : ""
                }
                alt="sort"
              />
            </div>
          )}
        </button>
      ) : (
        <div className="header_cell" style={{ cursor: "pointer" }}>
          <p>{label}</p>
        </div>
      )}
    </th>
  );

  const headerRenderer2 = ({ label, key, sortable, classn, width }, index) => (
    <th
      key={index}
      aria-sort={
        accordionKey === key
          ? isAccordionAscending
            ? "Ascending"
            : "Descending"
          : undefined
      }
      className={classn && classn}
      style={{ paddingLeft: label === "Sub Asset Class" ? 0 : "auto" }}
    >
      {sortable ? (
        <button
          className="header_cell tax_report_accordion_header_intdiv"
          onClick={() =>
            setAccordionKey(
              { key1: key },
              key === accordionKey ? !isAccordionAscending : false,
            )
          }
        >
          <p>{label}</p>
          {sortable && (
            <div
              className="accordion_table_header_child_icon"
              style={{ height: 12, width: 12 }}
            >
              <img
                src={
                  isAccordionAscending && accordionKey === key
                    ? sortedIcon
                    : !isAccordionAscending && accordionKey === key
                      ? sortedAtoz
                      : accordionKey !== key
                        ? unsortedIcon
                        : ""
                }
                alt="sort"
              />
            </div>
          )}
        </button>
      ) : (
        <div
          className="header_cell tax_report_accordion_header_intdiv"
          onClick={() =>
            setAccordionKey(
              { key1: key },
              key === accordionKey ? !isAccordionAscending : false,
            )
          }
        >
          <p>{label}</p>
        </div>
      )}
    </th>
  );

  const rowRenderer = (eachRowData, index) => (
    <>
      <tr key={index}>
        {(ReportsStore.taxType === "InterestDiv" ? intDivcolumns : columns).map(
          (column) => {
            if (column?.cellRenderer) {
              return (
                <>
                  <td
                    key={index}
                    style={{
                      borderBottomWidth: 0,
                    }}
                  >
                    {column?.cellRenderer(eachRowData, column.key, index)}
                  </td>
                </>
              );
            } else {
              return <td key={index}>{eachRowData[column.key]}</td>;
            }
          },
        )}
      </tr>
    </>
  );

  const handleBreadCrumbNavigation = (assetClass) => {
    setSortedColumn("");
    setDataTable([]);
    setShowTable([]);
    if (assetClass === "Total Equity Derivatives") {
      setCurrentStep("0");
      return;
    }
    setCurrentStep("0");
    ReportsStore.setTaxType(ReportsStore.taxType);
    setCurrentOpenAccordion(assetClass);
  };

  const columns2 = [
    {
      label: "Instrument Name",
      key: "displayName",
      sortable: false,
      id: 0,
      cellRenderer: instrumentNameCellRenderer2,
    },
    {
      label: "ISIN",
      key: "isin",
      sortable: true,
      id: 1,
      cellRenderer: instrumentNameCellRenderer,
      minWidth: "170px",
    },
    {
      label: "Folio No",
      key: "folioNo",
      sortable: true,
      cellRenderer: folioRenderer,
      id: 2,
      minWidth: "195px",
    },
    {
      label: "Security Class",
      key: "securityClass",
      sortable: true,
      id: 3,
      cellRenderer: instrumentNameCellRenderer,
      minWidth: "180px",
    },
    {
      label: "Quantity/Units",
      key: "quantity",
      sortable: true,
      id: 4,
      cellRenderer: instrumentAmtCellRenderer,
      minWidth: "180px",
    },
    {
      label: "Buy Date",
      key: "buyDate",
      sortable: true,
      id: 5,
      cellRenderer: instrumentDateCellRenderer,
      minWidth: "170px",
    },
    {
      label: "Sell Date",
      key: "sellDate",
      sortable: true,
      id: 6,
      cellRenderer: instrumentDateCellRenderer,
      minWidth: "170px",
    },
    {
      label: "Buy Price in ₹",
      key: "buyPrice",
      sortable: true,
      id: 7,
      cellRenderer: instrumentAmtCellRenderer,
      minWidth: "170px",
    },
    {
      label: "GF Price in ₹",
      key: "gfPrice",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      id: 8,
      minWidth: "170px",
    },
    {
      label: "Sell Price in ₹",
      key: "sellPrice",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      id: 9,
      minWidth: "170px",
    },
    {
      label: "Buy Value in ₹",
      key: "buyValue",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      minWidth: "170px",
      id: 10,
    },
    {
      label: "Sell Value in ₹",
      key: "sellValue",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      id: 11,
      minWidth: "170px",
    },
    {
      label: "Indexation Price",
      key: "indexationPrice",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      id: 12,
      minWidth: "175px",
    },
    {
      label: "Indexation Value",
      key: "indexationValue",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      id: 13,
      minWidth: "175px",
    },
    {
      label: "LTP",
      key: "ltp",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      id: 14,
      minWidth: "150px",
    },
    {
      label: "Taxable G/L with Indexation",
      key: "longTermCapitalGainsWithIndexation",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      id: 15,
      headerStyleClass: true,
      minWidth: "230px",
      classn: "big_col_1",
      currentSortKey: key1,
    },
    {
      label: "Gain/Loss",
      key: "longTermCapitalGainsWithoutIndexation",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      minWidth: "165px",
      classn: "big_col_2",
      id: 16,
      headerStyleClass: true,
      currentSortKey: key1,
    },
    {
      label: "Holding Days",
      key: "holdingDays",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
      id: 17,
      minWidth: "170px",
    },
    {
      label: "Short Term Gain/Loss",
      key: "shortTerm_GL",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
      id: 18,
      minWidth: "170px",
    },
    {
      label: "Brokerage",
      key: "brokerage",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      id: 19,
      minWidth: "170px",
    },
    {
      label: "Stamp Duty",
      key: "stampDuty",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      id: 20,
      minWidth: "170px",
    },
    {
      label: "STT Buy",
      key: "sttBuy",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      id: 21,
      minWidth: "165px",
    },
    {
      label: "Other Charges Buy",
      key: "otherChargesBuy",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      id: 22,
      minWidth: "180px",
    },
    {
      label: "STT Sell",
      key: "sttSell",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      id: 23,
      minWidth: "170px",
    },
    {
      label: "Other Charges Sell",
      key: "otherChargesSell",
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      id: 24,
      minWidth: "180px",
    },

    {
      label: "Quantity",
      key: "quantity",
      id: 27,
      sortable: false,
      cellRender: instrumentAmtCellRenderer,
      minWidth: "170px",
    },
    {
      label: "Dividend Date",
      key: "dividendDate",
      id: 28,
      sortable: true,
      cellRender: instrumentDateCellRenderer,
      minWidth: "170px",
    },

    {
      label: "Amount",
      key: "amount",
      id: 29,
      sortable: true,
      cellRender: instrumentAmtCellRenderer,
      minWidth: "170px",
    },
  ];

  const columns3 = [
    {
      label: "Instrument Name",
      key: "displayName",
      sortable: false,
      id: 0,
      cellRenderer: instrumentNameCellRenderer2,
    },
    {
      label: "",
      key: "",
      sortable: false,
      id: 25,
    },
    {
      label: "Quantity",
      key: "quantity",
      id: 27,
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
      width: "70%",
    },
    {
      label: "Dividend Date",
      key: "dividendDate",
      id: 28,
      sortable: true,
      cellRenderer: instrumentDateCellRenderer,
    },

    {
      label: "Amount",
      key: "amount",
      id: 29,
      sortable: true,
      cellRenderer: instrumentAmtCellRenderer,
    },
  ];

  const onApplyFilter = () => {
    setTimeout(() => {
      window.scrollTo({ top: 500, behavior: "smooth" });
    }, 200);

    setIsFilterApplied(true);
    ReportsStore.setTaxType("Asset");
    setCurrentStep("0");
    setCurrentOpenAccordion("");
    ReportsStore.updateTableDataLoader(true);
    ReportsStore.callTaxApi(
      `${fromDate.date}/${fromDate?.month}/${fromDate.year}`,
      `${toDate.date}/${toDate?.month}/${toDate.year}`,
    );
  };
  const onClearFilter = () => {
    ReportsStore.updateTableDataLoader(true);
    setIsFilterApplied(false);
    ReportsStore.setTaxDataDefault("assetData");
    ReportsStore.setTaxDataDefault("interestData");
    ReportsStore.setTaxType("Asset");
    setTimePeriod((prevState) => "current_month");
    ReportsStore.setSelectedAccount(userAccounts[0]);
    setTimeout(() => {
      ReportsStore.updateTableDataLoader(false);
    }, 1000);
  };

  const handleOpenModal = () => {
    BeforeEditColumnModalOpen({ assetClass: "" });
    setOpenFilterModal(true);
  };

  const handleColumns = () => {
    let arr2 = columns2;
    let arr = arr2.filter((column, index) => {
      return (column.id > 26 && column.id < 30) || column?.id === 0;
    });
    const aobj = {
      label: "",
      key: "",
      sortable: false,
      id: 25,
    };
    arr.splice(1, 0, aobj);
    setIntColumnsToDisplay(arr);
  };

  const handleResetOutSide = () => {
    const checkedIds = {
      0: true,
      3: true,
      4: true,
      5: true,
      6: true,
      7: true,
      8: true,
      9: true,
      10: true,
      15: true,
    };

    const arr = taxReportEditColumnsNames;
    let mappedArry = arr.map((data) => {
      return checkedIds[data.id]
        ? //data.id >= 0 && data.id < 8
          { ...data, checked: true }
        : { ...data, checked: false };
    });
    seTtaxReportEditColumnsNames(mappedArry);

    setColumnsToDisplay(
      getDisplayClms({
        sourceArr: columns2,
        refArr: mappedArry,
      }),
    );
  };

  const EmailReportSuccessContent = () => {
    return (
      <div className="email_success_container">
        <img
          className="email_success_img"
          src={emailSuccess}
          alt="email succes"
        />
        <p className="email_success_msg">
          Your report has been emailed to the registered Email ID
        </p>
        <div
          className="email_success_home_btn_wrapper"
          onClick={() => {
            const { isOffshoreOnly, navigateTo } = getOffshoreData();

            navigate(navigateTo, {
              state: isOffshoreOnly ? { from: OFFSHORE } : {},
            });
          }}
        >
          <p className="back_to_home_text">Back to Home</p>
          <button>
            <img src={homeBtnIcon} alt={homePageRoute} />
          </button>
        </div>
      </div>
    );
  };

  const EmailReportToContent = useMemo(() => {
    const emailReportToData = [
      {
        id: "selfEmail",
        name: "selfName",
        title: "Self",
      },
      {
        id: "csoEmail",
        name: "csoName",
        title: "CXO",
      },
      {
        id: "rmEmail",
        name: "rmName",
        title: "RM",
      },
      {
        id: "clientEmail",
        name: "clientName",
        title: "Client",
      },
    ];
    const handleChange = (id, name) => {
      ReportsStore.setEmailIdCreds({ id: id, name: name });
      setSelectedUser(id);
      setSelectedUsersName(name);
    };

    const handleReset = () => {
      setSelectedUser("selfEmail");
    };

    return (
      <div className="email_report_to_container">
        {ReportsStore.emailReportModalLoader && (
          <div className="email_report_to_loader_container">
            <img className="loader_gif" src={loaderGIF} alt="loading..." />
          </div>
        )}
        <div className="radio_btn_options_wrapper">
          {emailReportToData.map((userData) => (
            <div
              className="radio_btn_option cursor"
              onClick={() => handleChange(userData.id, userData.name)}
            >
              <button
                className="radio_btn_input"
                onClick={() => handleChange(userData.id, userData.name)}
              >
                {userData.id === selectedUser ? (
                  <FilledButton />
                ) : (
                  <EmptyButton />
                )}
              </button>
              <label className="radio_btn_label" for={userData.id}>
                {userData?.title}
              </label>
            </div>
          ))}
        </div>
        <div className="confirm_email_wrapper">
          <p className="confirm_email_text">Confirm Email ID</p>
          <p className="user_email">
            {UserStore.emailIdDataForTax?.[selectedUser] || "-"}
          </p>
        </div>
        <div className="footer_reset_apply_wrapper">
          <button className="reset_btn" onClick={handleReset}>
            <p className="reset_text">Reset</p>
          </button>

          <ArrowButton
            type="next"
            label="Apply"
            onClick={() => {
              ReportsStore.updateEmailReportModalLoader(true);
              handlePdfClick(
                "1",
                storeSelectedUser,
                UserStore.emailIdDataForTax?.[selectedUsersName],
              );
            }}
          />
        </div>
      </div>
    );
  }, [
    selectedUser,
    storeSelectedUser,
    // UserStore.emailIdDataForTax?.[selectedUser],
    handlePdfClick,
    selectedUsersName,
    ReportsStore.emailReportModalLoader,
  ]);

  useEffect(() => {
    AuthStore.updateLoadingFullScreen(true);
    if (UserStore.isHydrated) {
      setLoading(false);

      const asOfDate = getAsOfDate(UserStore.asOfDate);

      if (asOfDate) {
        setCookie("asOfDate", asOfDate);
        // const asOfArr = asOfDate?.split("-");
        // setMinDate(`${asOfArr[0] - 2}-${asOfArr[1]}-${asOfArr[1]}`);
      }

      AuthStore.updateLoadingFullScreen(true);
      window.scrollTo(0, 0);
      ReportsStore.setTaxType("Asset");
      const user_type = getDecodedToken()?.user_type;
      ReportsStore.setUsersAccount();
      if (UserStore?.selectedClientId === "0" && user_type !== "manager") {
        ReportsStore.setCanCallEmailApi(true);
        ReportsStore.getFamilyClients("tax");
      } else {
        if (
          getCookie("isPrimary") === "true" &&
          (user_type === "customer" || user_type === "employee") &&
          UserStore?.selectedClientId !== "0"
        ) {
          ReportsStore.setMapData([UserStore.userData]);
          ReportsStore.getSingleUsersAccount(getCookie("userid"), "tax");
        } else if (
          getCookie("isPrimary") === "true" &&
          (user_type === "customer" || user_type === "employee")
        ) {
          ReportsStore.setCanCallEmailApi(true);
          ReportsStore.getFamilyClients("tax");
        } else if (
          user_type === "customer" ||
          user_type === "employee" ||
          user_type === "manager"
        ) {
          ReportsStore.setMapData([UserStore.userData]);
          ReportsStore.setCanCallEmailApi(false);
          ReportsStore.getSingleUsersAccount(getCookie("userid"), "tax");
        }
      }
    }
  }, [
    userHydrated,
    //UserStore.isHydrated
  ]);

  useEffect(() => {
    if (ReportsStore.emailSendSuccess) {
      setEmailReportToOpen(false);
      setEmailReportSuccessOpen(true);
      ReportsStore.setEmaiSendStatus("emailSendSuccess", false);
    }
  }, [
    emailSendSuccess,
    //  ReportsStore.emailSendSuccess
  ]);

  useEffect(() => {
    if (
      ReportsStore.emaiDataGetSuccess &&
      getDecodedToken()?.user_type !== "customer"
    ) {
      setEmailReportToOpen(true);
      ReportsStore.setEmaiSendStatus("emaiDataGetSuccess", false);
    } else if (ReportsStore.emaiDataGetSuccess) {
      ReportsStore.setEmaiSendStatus("emaiDataGetSuccess", false);
    }
  }, [
    emailDataSuccess,
    //  ReportsStore.emaiDataGetSuccess
  ]);

  useEffect(() => {
    if (UserStore.isHydrated) {
      const tkn = getDecodedToken()?.user_type;
      ReportsStore.setEmailIdCreds({
        id: tkn === "employee" ? "selfEmail" : "clientEmail",
        name: tkn === "employee" ? "selfName" : "clientName",
      });

      const oneDayDef = 86400000;
      const as_of_date = storedAsOfDate ? storedAsOfDate : asOfDate;
      const dateObjofAsOfDate = new Date(as_of_date);

      const forThisYearFirstDate = new Date(
        `${
          dateObjofAsOfDate.getMonth() - 3 < 0
            ? dateObjofAsOfDate.getFullYear() - 1
            : dateObjofAsOfDate.getFullYear()
        }-04`,
      );
      const prevYearLastDate = new Date(
        forThisYearFirstDate.getTime() - oneDayDef,
      );
      const prevYearFirstDate = new Date(
        `${prevYearLastDate.getFullYear() - 1}-04`,
      );

      let newFromdate;
      let formattedFromdate;
      let newTodate;
      let formattedTodate;
      const currentQuarter = Math.floor(dateObjofAsOfDate.getMonth() / 3);
      const quarterStartDate = new Date(
        dateObjofAsOfDate.getFullYear(),
        currentQuarter * 3,
      );
      if (!resetedFromDate && !resetedToDate) {
        newFromdate = new Date(
          dateObjofAsOfDate.getFullYear(),
          dateObjofAsOfDate.getMonth(),
          1,
        );
        formattedFromdate = formatDate({ date: newFromdate });
        setResetedFromDate(convertDateToObj(formattedFromdate));
        setResetedToDate(convertDateToObj(as_of_date));
      }
      switch (timePeriod) {
        case "current_month":
          newFromdate = new Date(
            dateObjofAsOfDate.getFullYear(),
            dateObjofAsOfDate.getMonth(),
            1,
          );
          formattedFromdate = formatDate({ date: newFromdate });
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(as_of_date));
          break;
        case "previous_month":
          newFromdate = new Date(
            dateObjofAsOfDate.getFullYear(),
            dateObjofAsOfDate.getMonth() - 1,
            1,
          );
          formattedFromdate = formatDate({ date: newFromdate });
          let dummyDateObj = new Date(as_of_date);
          let dummyTime = dummyDateObj?.setDate(1);
          newTodate = new Date(dummyTime - oneDayDif);
          formattedTodate = formatDate({ date: newTodate });
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(formattedTodate));
          break;
        case "current_quarter":
          newFromdate = quarterStartDate;
          formattedFromdate = formatDate({ date: newFromdate });
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(as_of_date));
          break;
        case "previous_quarter":
          const currentQuarterStartDate = quarterStartDate;
          const currentQuarterEndDate = new Date(
            quarterStartDate.getFullYear(),
            quarterStartDate.getMonth() + 2,
            0,
          );
          const previousQuarterStartDate = new Date(
            currentQuarterStartDate.getFullYear(),
            currentQuarterStartDate.getMonth() - 3,
          );
          const previousQuarterEndDate = new Date(
            currentQuarterEndDate.getFullYear(),
            currentQuarterEndDate.getMonth() - 1,
            0,
          );

          newFromdate = previousQuarterStartDate;
          formattedFromdate = formatDate({ date: newFromdate });
          newTodate = previousQuarterEndDate;
          formattedTodate = formatDate({ date: newTodate });
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(formattedTodate));
          break;
        case "current_fy":
          setFromDate(
            convertDateToObj(formatDate({ date: forThisYearFirstDate })),
          );
          setToDate(convertDateToObj(as_of_date));

          break;
        case "previous_fy":
          setFromDate(
            convertDateToObj(formatDate({ date: prevYearFirstDate })),
          );
          setToDate(convertDateToObj(formatDate({ date: prevYearLastDate })));
          break;
        default:
          break;
      }
    }
    // eslint-disable-next-line
  }, [timePeriod, UserStore.isHydrated]);

  useEffect(() => {
    trackEventWithScreen({ eventName: REPORTS_PAGE, screenName: TAX });

    logEvents(REPORTS_PAGE, {
      screenName: TAX,
    });

    setColumnsToDisplay(
      getDisplayClms({
        sourceArr: columns2,
        refArr: taxReportEditColumnsNames,
      }),
    );

    const aobj = {
      label: "",
      key: "",
      sortable: false,
      id: 25,
    };

    let arr3 = columns2;
    let arr4 = arr3.filter((column, index) => {
      return (column?.id > 26 && column?.id < 30) || column?.id === 0;
    });
    arr4.splice(1, 0, aobj);
    setIntColumnsToDisplay(arr4);
    // eslint-disable-next-line
  }, []);

  const handleSort = (key) => {
    if (ReportsStore.taxType === "Asset") {
      setSortedColumn(key);
      setIsSortedColumnAscending(!isSortedColumnAscending);
    } else {
      setTableKey({ key1: key }, key === tableKey ? !isTableAscending : false);
    }
  };

  useEffect(() => {
    handleSort();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    return () => {
      ReportsStore.setAllAccountStatus(false);
    };
  }, []);

  const handleTimePeriodReset = () => {
    setFromDate(initialFromDate);
    setToDate(initialToDate);
  };

  useEffect(() => {
    if (datePickerModalOpen) {
      setInitialFromDate(fromDate);
      setInitialToDate(toDate);
    }
    // eslint-disable-next-line
  }, [datePickerModalOpen]);

  function handleScrollStartDiv() {
    const scrollTop = tBodyRef?.current?.scrollTop;
    if (scrollTop > 30) setIsTableScrolled(true);
    else if (scrollTop < 29) setIsTableScrolled(false);
  }

  const handleScroll = () => {
    const position = window.pageYOffset;
    if (position >= 730) setScrollPosition(position);
    else if (position <= 729) setScrollPosition(position);
  };

  useEffect(() => {
    // Attach the event listener when the component mounts
    window.addEventListener("scroll", handleScroll);
    // Detach the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const setDataTable = (data) => {
    setShowTable(data);
    setSortedColumn("");
    setTable(data);
  };

  useEffect(() => {
    const rowData = table;

    const sortedColumnLocal = sortedColumn;
    if (rowData) {
      setUpdating(true);
      if (!sortedColumnLocal) {
        setShowTable(table);
      }

      let sortedData = [];

      if (taxReportAlphanumKeys[sortedColumn]) {
        sortedData = [...rowData]?.sort((a, b) =>
          (b?.[sortedColumn] || "").localeCompare(a?.[sortedColumn] || ""),
        );
        setShowTable(
          !isSortedColumnAscending ? sortedData : sortedData?.reverse(),
        );
      } else if (taxReportNumberKeys[sortedColumn]) {
        sortedData = [...rowData]?.sort(
          (a, b) =>
            Number(a?.[sortedColumn] || 0) - Number(b?.[sortedColumn] || 0),
        );
        setShowTable(
          !isSortedColumnAscending ? sortedData : sortedData?.reverse(),
        );
      } else if (taxReportDateKeys[sortedColumn]) {
        sortedData = [...rowData]?.sort((a, b) => {
          let aa = a?.[sortedColumn]?.split("-")?.join();
          let bb = b?.[sortedColumn]?.split("-")?.join();

          return aa < bb ? -1 : aa > bb ? 1 : 0;
        });

        setShowTable(
          !isSortedColumnAscending ? sortedData.reverse() : sortedData,
        );
      }

      setUpdating(false);
    }
  }, [sortedColumn, isSortedColumnAscending, table]);

  const getSortingImage = ({ key, key1, isAscending }) => {
    return isAscending && key1 === key
      ? sortedIcon
      : !isAscending && key1 === key
        ? sortedAtoz
        : key1 !== key
          ? unsortedIcon
          : "";
  };

  const getSortingImageIntDiv = ({ key, isAscending }) => {
    return isAscending ? sortedIcon : sortedAtoz;
    // : unsortedIcon
  };

  return (
    <Observer>
      {() => (
        <>
          <div>
            <PageTitle title={"Portfolio Report"} />
            {AuthStore.isLoadingFullScreen ||
            !UserStore.isHydrated ||
            loading ? (
              <LoadingScreen />
            ) : (
              <>
                <Header type="reports" />
                <div className="reports_outer_main">
                  <div className="tax_header_container">
                    <PageHeading headingClass="head" headingText="Tax Report" />
                    {/* <div ref={exportTaxRef}>
                      <PopupMenu
                        position={{ top: "59px", right: "2px" }}
                        setOpen={setNiftyMenu}
                        open={niftyMenu}
                        MenuContent={ExtractDataContent}
                      >
                        <PopupButton />
                      </PopupMenu>
                    </div> */}
                    <div className="reports-export-wrapper tax-report-export-wrapper">
                      <ExportReportList
                        exportExcel={() => {
                          //setNiftyMenu(false);
                          ReportsStore.setITaxSendEmail("0");
                          ReportsStore.setTaxDates(fromDate, "taxFromDate");
                          ReportsStore.setTaxDates(toDate, "taxToDate");
                          ReportsStore.setDownloadTrigger([
                            ...ReportsStore.downloadTrigger,
                            {},
                          ]);
                          handleClickToDownload({ path: "download" });
                        }}
                        exportPdf={() => {
                          // Opens new tab for downloading pdf and in use effect we are calling api for pdf
                          // Allroutes page downloads the actual file by the auto click on a anchor tag and using cookies

                          const pdfFromDate = getTaxPDFDate({
                            data: fromDate,
                          });
                          const pdfToDate = getTaxPDFDate({ data: toDate });

                          ReportsStore.setTaxDates(
                            pdfFromDate,
                            "taxPdfDownloadFromDate",
                          );
                          ReportsStore.setTaxDates(
                            pdfToDate,
                            "taxPdfDownloadToDate",
                          );
                          // setNiftyMenu(false);
                          ReportsStore.setDownloadTrigger([
                            ...ReportsStore.downloadTrigger,
                            {},
                          ]);
                          handleClickToDownload({
                            path: `tax-report/pdf-file-download`,
                          });
                        }}
                        emailReport={() => {
                          handleEmailREport("1");
                        }}
                        buttonProps={{
                          buttonType: "reportExport",
                        }}
                        popupClassName={{
                          open: "clicked-hover",
                          close: "",
                          wrapperClass: "popup_menu_container",
                        }}
                        restrictHover={true}
                        itemRefs={exportItemRefs}
                        menuItems={exportDataMenuTaxReport}
                        accessibilityValues={{
                          buttonId: "export-dropdown",
                          ariaHaspopup: "menu",
                          ariaControls: "extract-menu",
                          ariaLabel: "Extract Data",
                        }}
                      />
                    </div>
                  </div>
                  <div className="reports_yellow_container tax_report_yellow_container">
                    <div className="tax_report_first_container">
                      <RadioGroup
                        heading="Time Period"
                        name="time_period"
                        radioBtnArray={TaxtimePeriodRadioBtnsData}
                        handleChange={handleTimePeriodChange}
                        value={timePeriod}
                        radioBtnsPerRow={8}
                        groupId={"tax-time-period"}
                        groupName={"tax-radio-group1"}
                      />
                    </div>
                    <div className="tax_report_second_container">
                      <div className="tax_report_date_picker">
                        <DatePicker2
                          timePeriod={timePeriod}
                          fromDate={fromDate}
                          toDate={toDate}
                          setFromDate={setFromDate}
                          setToDate={setToDate}
                          initialFromDate={initialFromDate}
                          initialToDate={initialToDate}
                          resetedFromDate={resetedFromDate}
                          resetedToDate={resetedToDate}
                          handleReset={handleTimePeriodReset}
                          // isActive={timePeriod === "custom"}
                          isActive={true}
                          open={datePickerModalOpen}
                          setOpen={() => {
                            handleTimePeriodChange("custom");
                            setDatePickerModalOpen(true);
                          }}
                          onClose={() => setDatePickerModalOpen(false)}
                          //minDate={minDate}
                          setDatesWithCustomLogic={calenderSetterTaxReport}
                          validateDate={validateTaxReportDate}
                          validationMessage={dateErrorMessagetaxReport}
                        />
                      </div>
                      <div className="tax_report_dropdown_container">
                        <div className="dropdown_container">
                          {false && (
                            <GoldenDropDown
                              heading={selectedAssetClass.title}
                              ReportMenuContent={AllAssetClassMenuContent}
                              reportsMenuOpen={allAssetClassMenuOpen}
                              setReportsMenuOpen={setAllAssetClassMenuOpen}
                              position={{ top: "56px", left: "0px" }}
                              showArrow={false}
                              isDisabled={true}
                              dropDownContainerClass="all_accounts_dropdown"
                            />
                          )}

                          <DropdownWithOptions
                            heading={`${
                              !ReportsStore.marginAllAccountsSuccess
                                ? "Loading..."
                                : UserStore?.selectedAccount?.accountName
                            }`}
                            headingValue={UserStore.selectedAccount}
                            setHeadingValue={(data) => {
                              ReportsStore.setSelectedAccount(data);
                            }}
                            position={taxAccountDDPosition}
                            showPopup={userAccounts?.length > 1}
                            showArrow={false}
                            // disabledPopup={
                            //   ReportsStore.usersAccounts.length === 1
                            // }
                            isDisabled={!ReportsStore.marginAllAccountsSuccess}
                            popupClassName={{
                              wrapperClass: "popup_menu_container",
                              dropDownContainerClass: "all_accounts_dropdown",
                              popupMenuClass: "tax-menu-content",
                            }}
                            restrictHover={true}
                            OPTIONS={userAccounts}
                            accessibilityValues={{
                              buttonId: "",
                              ariaHaspopup: "radiogroup",
                              ariaControls: "accounts-options",
                              ariaLabel: "Accounts Selection",
                            }}
                            dataKey="accountCode"
                            dataValueKey="accountName"
                          />
                        </div>
                      </div>
                      <div
                        className="tax_report_changes_radio"
                        style={{ display: "none" }}
                      >
                        <RadioGroup
                          heading="Charges"
                          name="charges"
                          radioBtnArray={changesRadioBtnsData}
                          handleChange={handleChangesRadioChange}
                          value={ReportsStore.selectedCharge}
                          radioBtnsPerRow={2}
                          groupId={"tax-charges"}
                          groupName={"tax-radio-group2"}
                        />
                      </div>
                    </div>
                    <div className="tax_report_apply_filter">
                      <ApplyFilter
                        customCss="reusable-button"
                        onApplyFilter={onApplyFilter}
                        onClearFilter={onClearFilter}
                      />
                    </div>
                    <ul className="tax_report_notes notes">
                      {taxReportBulletPoints?.map((points) => (
                        <li>
                          <span></span>
                          {points}
                        </li>
                      ))}
                    </ul>
                  </div>
                  {ReportsStore.tableDataLoader && isFilterApplied ? (
                    <div className="report_table_loader">
                      <div className="report_loader_wrapper tax_report">
                        <p ref={scrollRef}>
                          This usually takes 2 to 5 mins to display
                        </p>
                        <img
                          className="loading_gif"
                          src={loaderGIF}
                          alt="loading..."
                        />
                      </div>
                    </div>
                  ) : (
                    isFilterApplied && (
                      <>
                        {currentStep === "0" ? (
                          <div className="tax_report_tabs">
                            <Tabs
                              selectedTab={ReportsStore.taxType}
                              onSelect={(value) => {
                                ReportsStore.setTaxType(value);
                                setKeyForOrdering(
                                  {
                                    key1:
                                      ReportsStore.taxType === "Asset"
                                        ? "shortTerm_GL"
                                        : "amount",
                                  },
                                  false,
                                );
                                ReportsStore.updateTableDataLoader(true);
                                ReportsStore.callTaxApi(
                                  `${fromDate?.date}/${fromDate?.month}/${fromDate?.year}`,
                                  `${toDate?.date}/${toDate?.month}/${toDate?.year}`,
                                );
                                if (value === "InterestDiv") {
                                  handleColumns();
                                }
                              }}
                              tabs={taxReportTabs}
                            />
                            {ReportsStore.taxType === "Asset" &&
                              ReportsStore.assetData.length !== 0 && (
                                <>
                                  <TableAccordion
                                    currentOpenAccordion={currentOpenAccordion}
                                    headers={accordionTableHeaderData}
                                    handleAccordion={(name, idx, rowData) =>
                                      handleAccordion(name, idx, rowData)
                                    }
                                    columns={columns}
                                    headerRenderer={(props) =>
                                      headerRenderer(props)
                                    }
                                    accordionData={accordionData}
                                    rowRenderer={(row, i) =>
                                      rowRenderer(row, i)
                                    }
                                    className="tax-report-accordion-content-border"
                                    tableClass="tax_report_accordion_table accordion_table"
                                    handleFilter={(title, key) =>
                                      handleFilter(title, key)
                                    }
                                    styles={{
                                      cursor: "pointer",
                                      whiteSpace: "nowrap",
                                    }}
                                    type={"Asset"}
                                    getSortingImage={({ key }) =>
                                      getSortingImage({
                                        key,
                                        key1,
                                        isAscending,
                                      })
                                    }
                                    arrData={arrData}
                                    tableData={ReportsStore.assetData}
                                    totalValues={[
                                      {
                                        value:
                                          ReportsStore.assetTotal
                                            ?.total_ShortTerm_GL,
                                      },
                                      {
                                        value:
                                          ReportsStore.assetTotal
                                            ?.total_LongTerm_GL,
                                      },
                                    ]}
                                    totalClass={"totalvaluetable"}
                                    compareWithKey={key1}
                                    isAscending={isAscending}
                                  />
                                </>
                              )}
                            {ReportsStore.taxType === "Asset" &&
                              ReportsStore.assetData.length === 0 && (
                                <NoDataScreen />
                              )}
                            {ReportsStore.taxType === "InterestDiv" &&
                              ReportsStore.interestData.length !== 0 && (
                                <>
                                  <TableAccordion
                                    currentOpenAccordion={currentOpenAccordion}
                                    headers={
                                      intDivOthersaccordionTableHeaderData
                                    }
                                    handleAccordion={(name, idx, rowData) =>
                                      handleAccordion(name, idx, rowData)
                                    }
                                    columns={intDivcolumns}
                                    headerRenderer={(props) =>
                                      headerRenderer2(props)
                                    }
                                    accordionData={accordionData}
                                    rowRenderer={(row, i) =>
                                      rowRenderer(row, i)
                                    }
                                    className="tax-report-accordion-content-border-int"
                                    tableClass="tax_report_accordion_table accordion_table int_div_others"
                                    handleFilter={(title, key) =>
                                      handleFilter(title, key)
                                    }
                                    styles={{}}
                                    type={"InterestDiv"}
                                    getSortingImage={({ key }) =>
                                      getSortingImageIntDiv({
                                        key,
                                        isAscending,
                                      })
                                    }
                                    arrData={arrData}
                                    tableData={ReportsStore.interestData}
                                    totalValues={[
                                      {
                                        value:
                                          ReportsStore.intTotal?.totalAmount,
                                      },
                                    ]}
                                    totalClass={"intdivtotal"}
                                    border={true}
                                    activeClass={"tax-report-active-class"}
                                    inactiveClass={"tax-report-inactive-class"}
                                    compareWithKey={"amount"}
                                    isAscending={isAscending}
                                  />
                                </>
                              )}

                            {ReportsStore.taxType === "InterestDiv" &&
                              ReportsStore.interestData.length === 0 && (
                                <NoDataScreen />
                              )}
                          </div>
                        ) : (
                          <>
                            <div className="portfolio_breadcrumbs_div">
                              <div className="portfolio_breadcr">
                                <nav className="portfolio_breadcrumb">
                                  <ul>
                                    <li>
                                      <div
                                        className={"breadlink"}
                                        onClick={() =>
                                          handleBreadCrumbNavigation(
                                            breadCrumbData.assetClass,
                                          )
                                        }
                                      >
                                        <span>{breadCrumbData.assetClass}</span>
                                      </div>
                                    </li>
                                    <li>
                                      <div
                                        className={"lightlink blueTextColor"}
                                      >
                                        <img
                                          style={{
                                            marginRight: "5.5px",
                                            marginLeft: "6px",
                                          }}
                                          className="bread_a"
                                          src={breadCrumbArrow}
                                          alt="arr"
                                        />

                                        <span>
                                          {breadCrumbData.subAssetClass}
                                        </span>
                                      </div>
                                    </li>
                                  </ul>
                                </nav>
                              </div>
                            </div>
                            <div className="tax_report_sub_asset_class_header_container">
                              <label className="sub_asset_class_heading">{`${breadCrumbData?.subAssetClass} (${table.length})`}</label>
                              {ReportsStore.taxType !== "InterestDiv" && (
                                <div className="reset_edit_column_container">
                                  <button
                                    className="reset_col_btn"
                                    onClick={handleResetOutSide}
                                  >
                                    Reset Columns
                                  </button>
                                  <button
                                    className="edit_col_btn"
                                    onClick={() => handleOpenModal()}
                                  >
                                    <div className="column_icon">
                                      <span className="black_column_icon"></span>
                                      <span className="black_column_icon"></span>
                                      <span className="black_column_icon"></span>
                                    </div>
                                    Edit Columns
                                  </button>
                                </div>
                              )}
                            </div>
                            <div
                              ref={tBodyRef}
                              onScroll={handleScrollStartDiv}
                              className="tax_report_table_wrapper tax_report_table_wrapper_scroll"
                              style={{
                                maxHeight: "92vh",
                                overflowY:
                                  scrollPosition >= 730 ? "scroll" : "hidden",
                                overflowX: "auto",
                              }}
                            >
                              {ReportsStore.taxType !== "Asset" ? (
                                <Table
                                  data={tableData}
                                  columns={columns3}
                                  forThirdTd={"thirdTd"}
                                  tableClass="equity_summary_table"
                                  handleSort={(key) => handleSort(key)}
                                  sortKey={tableKey}
                                  isAscending={isTableAscending}
                                  isFirstElementScrolled={isTableScrolled}
                                />
                              ) : updating ? (
                                <div
                                  className="email_report_to_loader_container"
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <img
                                    style={{ height: "40px" }}
                                    className="loader_gif"
                                    src={loaderGIF}
                                    alt="loading..."
                                  />
                                </div>
                              ) : (
                                <Table
                                  data={showTable}
                                  columns={columnsToDisplay}
                                  forThirdTd={
                                    ReportsStore.taxType !== "Asset" &&
                                    "thirdTd"
                                  }
                                  tableClass="equity_summary_table"
                                  handleSort={(key) => handleSort(key)}
                                  sortKey={sortedColumn}
                                  isAscending={isSortedColumnAscending}
                                  isFirstElementScrolled={isTableScrolled}
                                />
                              )}
                            </div>

                            <Modal
                              onClose={() => setOpenFilterModal(false)}
                              open={openFilterModal}
                              width="905px"
                              minWidth="905px"
                              title="Filters"
                              modalContainerClass="tax_reports_filter_modal_container"
                            >
                              <FilterModalContent />
                            </Modal>
                          </>
                        )}
                      </>
                    )
                  )}
                </div>
              </>
            )}
          </div>
          <Modal
            onClose={() => setEmailReportSuccessOpen(false)}
            open={emailReportSuccessOpen}
            title={"Report Sent"}
            width={"497px"}
            showCloseIcon={true}
          >
            <EmailReportSuccessContent />
          </Modal>
          <Modal
            onClose={() => setEmailReportToOpen(false)}
            open={emailReportToOpen}
            title={"Email Report to"}
            width={"810px"}
            showCloseIcon={true}
          >
            {EmailReportToContent}
          </Modal>

          <Modal
            modalStyle={errorModalPadding}
            showCloseIcon={true}
            open={UserStore?.taxReportDownloadError}
            onClose={() => {
              UserStore.setTaxReportDownloadError(false);
            }}
          >
            <ErroModalContent
              msg={"Something went wrong, Please try again after sometime."}
              onClick={() => UserStore.setTaxReportDownloadError(false)}
            />
          </Modal>

          <Modal
            modalStyle={errorModalPadding}
            showCloseIcon={true}
            open={openErrorModal}
            onClose={() => setOpenErrorModal(false)}
          >
            <ErroModalContent
              msg={"Something went wrong, Please try again after sometime."}
              onClick={() => setOpenErrorModal(false)}
            />
          </Modal>
        </>
      )}
    </Observer>
  );
});

export default TaxReport;
